import React from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';
import { Link } from '@paygreen/paygreen-ui';

export const CustomLogoSize = styled.div`
    img {
        height: ${(props) => props.blockHeight};
        width: ${(props) => props.blockWidth};
    }
`;

export const FileUploadContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${(props) => props.theme.space.lg};
    border: dashed
        ${(props) =>
            props.theme.line +
            ' ' +
            transparentize(0.9, props.theme.wab.black00)};
    border-radius: ${(props) => props.theme.radius.sm};
    background-color: ${(props) =>
        props.isDragActive
            ? transparentize(0.8, props.theme.color.secondary.main)
            : props.theme.wab.white10};
    transition: all ${(props) => props.theme.transition.xs};
    margin-bottom: ${(props) => props.theme.space.xs};

    .upload-text {
        color: ${(props) =>
            props.isDragActive
                ? props.theme.color.secondary.main
                : props.theme.wab.grey30};
    }

    &:hover,
    &:active,
    &:focus {
        background-color: ${(props) =>
            transparentize(0.8, props.theme.color.secondary.main)};

        .upload-text {
            color: ${(props) => props.theme.color.secondary.main};
        }
    }

    @media ${(props) => props.theme.screen.max.sm} {
        padding: ${(props) => props.theme.space.sm};
    }
`;

export const FileUploadInput = styled.input`
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    border: none;

    &:focus {
        outline: none;
    }
`;

export const ImageContainer = styled.span`
    position: relative;
    padding: ${(props) => props.theme.space.xs};
    border: solid
        ${(props) =>
            (props.hasBorder
                ? props.theme.line
                : '0px') + ' ' + transparentize(0.9, props.theme.wab.black00)};
    border-radius: ${(props) => props.theme.radius.sm};

    figure {
        align-items: center;
        display: flex;
        justify-content: center;
        width: ${(props) => props.theme.blockSpace.xl};
        height: ${(props) => props.theme.blockSpace.xl};

        @media ${(props) => props.theme.screen.max.md} {
            width: ${(props) => props.theme.blockSpace.md};
            height: ${(props) => props.theme.blockSpace.md};
        }

        img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
            width: auto;
        }
    }
`;

export const FormatedLink = ({ to, children }) => (
    <a href={to} target="_blank" rel="noopener noreferrer">
        <Link colorTheme="secondary">{children}</Link>
    </a>
);
